import React, { useEffect, useState } from "react";
// import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import { useNavigate } from "react-router-dom";
import { all_routes } from "../../../Router/all_routes";
import axios from "axios";
import {
  API_BASE_URL,
  JSON_BASE_API_URL,
  SIGN_IN_DETAILS,
} from "../../../Config";
// import footerLogo1 from "./full logo- white.avif";
// import { Spin } from "antd";
import footerLogo1 from "./full logo- white.avif";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import { Spin } from "antd";

import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCoverflow, Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import "swiper/css/navigation";

const Signin = () => {
  const [isPasswordVisible, setPasswordVisible] = useState(false);
  const [Username, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setloading] = useState(false);
  const [activeSlide, setActiveSlide] = useState(0);
  const navigate = useNavigate();
  const route = all_routes;

  const [featureCards, setFeatureCards] = useState([]);
  const [dataloading, setdataloading] = useState(false);

  console.log(dataloading);
  const [featureCarouselSlides, setFeatureCarouselSlides] = useState([]);

  // const [topbar, setTopBar] = useState({});

  const [title, setTitel] = useState([]);

  // const [svgicons, setSvgIcons] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  console.log(errorMessage);

  useEffect(() => {
    const fetchData = async () => {
      setdataloading(true);
      try {
        const res = await axios.get(`${JSON_BASE_API_URL}/ibiz-content`);
        const data = res.data;
        // setTopBar(data.topbar || {});
        // setSvgIcons(data.featureCards || []);
        setTitel(data.titleSection || []);
        setFeatureCards(data.cards || []);
        setFeatureCarouselSlides(data.carousel || []);
      } catch (error) {
        console.error("Error fetching content:", error);
      } finally {
        setdataloading(false);
      }
    };

    fetchData();
  }, []);

  const togglePasswordVisibility = () => {
    setPasswordVisible((prev) => !prev);
  };

  // const handleLogin = async (e) => {
  //   e.preventDefault();
  //   setloading(true);

  //   try {
  //     const response = await axios.post(
  //       `${ROLL_CALL_API_BASE_URL}portal/user/login`,
  //       {
  //         username: Username,
  //         password: password,
  //       }
  //     );

  //     console.log("Login Response:", response);

  //     const { ResultData } = response.data;
  //     const { Token, IsAdmin, SuperId } = ResultData;

  //     if (Token && IsAdmin && SuperId) {
  //       sessionStorage.setItem("authToken", Token);
  //       sessionStorage.setItem("userData", JSON.stringify(ResultData));
  //       sessionStorage.setItem("superId", SuperId);

  //       try {
  //         const menuResponse = await fetch(
  //           `${ROLL_CALL_API_BASE_URL}portal/access/getmenu?UserId=${ResultData.UserId}`,
  //           {
  //             method: "GET",
  //             headers: {
  //               "Content-Type": "application/json",
  //               Authorization: `Bearer ${Token}`,
  //             },
  //           }
  //         );

  //         const menuData = await menuResponse.json();
  //         // after you get menuData from API
  //         if (menuData?.status && Array.isArray(menuData.ResultData)) {
  //           sessionStorage.setItem(
  //             "userMenu",
  //             JSON.stringify(menuData.ResultData)
  //           );
  //         }
  //         if (menuData?.status && Array.isArray(menuData.ResultData)) {
  //           const flatPermissions = {};

  //           const flatten = (items) => {
  //             items.forEach((item) => {
  //               // store permission only if link is valid
  //               if (item.link && item.link !== "#") {
  //                 flatPermissions[item.link] = {
  //                   canRead: item.canRead,
  //                   canWrite: item.canWrite,
  //                   canDelete: item.canDelete,
  //                   canExport: item.canExport,
  //                 };
  //               }

  //               // if submenu exists, recurse no matter how deep
  //               if (
  //                 Array.isArray(item.submenuItems) &&
  //                 item.submenuItems.length > 0
  //               ) {
  //                 flatten(item.submenuItems);
  //               }
  //             });
  //           };

  //           flatten(menuData.ResultData);

  //           sessionStorage.setItem(
  //             "rollcall-permissions",
  //             JSON.stringify(flatPermissions)
  //           );

  //           console.log("Saved permissions map:", flatPermissions);
  //         }
  //       } catch (err) {
  //         console.error("Menu API error:", err);
  //       }

  //       navigate(`/${ResultData.DefaultPath}`);
  //     } else {
  //       alert("Access denied. Only Admins can access the dashboard.");
  //     }
  //   } catch (error) {
  //     alert("Login failed. Please check your credentials.");
  //     console.error("Login error:", error);
  //   } finally {
  //     setloading(false);
  //   }
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setloading(true);
    setErrorMessage("");

    try {
      const trimmedUsername = Username.replace(/\s/g, "");
      const trimmedPassword = password.replace(/\s/g, "");
      const response = await fetch(`${API_BASE_URL}${SIGN_IN_DETAILS}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          Name: trimmedUsername,
          Password: trimmedPassword,
        }),
      });

      const data = await response.json();
      console.log | data;

      if (data.Status && data.ResultData && data.ResultData.length > 0) {
        sessionStorage.clear();
        localStorage.clear();
        sessionStorage.setItem(
          "userData",
          JSON.stringify(data["ResultData"][0]),
        );
        setloading(false);
        if (data.ResultData[0].InitialPath != null) {
          navigate(`/${data.ResultData[0].InitialPath}`, { replace: true });
          window.location.reload();
        } else {
          navigate("/product-list", { replace: true });
          window.location.reload();
        }
      } else {
        setloading(false);
        setErrorMessage("*Invalid Credentials..!");
        alert("Invalid Credentials");
      }
    } catch (error) {
      setloading(false);
      console.error("Error during fetch:", error);
      setErrorMessage("*An error occurred. Please try again.");
      alert("Invalid Credentials please try Again");
    }
  };

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    if (token) {
      navigate(route.rollcalldashboard, { replace: true });
    }
  }, []);

  useEffect(() => {
    const slideTimer = setInterval(() => {
      setActiveSlide((prev) => (prev + 1) % featureCarouselSlides.length);
    }, 2200);

    return () => clearInterval(slideTimer);
  }, [featureCarouselSlides.length]);

  return (
    <>
      <style>
        {`
.solutions-swiper .swiper-slide {
  width: 400px;
  height: auto;
}

.solution-card {
  display: flex;
  flex-direction: row;

  height: 200px;
  border-radius: 18px;
  overflow: hidden;
  object-fit:fill;

  background: #fff;
  box-shadow: 0 8px 20px rgba(0,0,0,.08);
  transition: all .4s ease;
}

.swiper-slide-active .solution-card {
  transform: scale(1.03);
  box-shadow: 0 18px 35px rgba(0,0,0,.15);
}



.solution-image {
  width: 100%;
  height: 100%;
  object-fit: fill;
}


           `}
      </style>

      <div className="main-wrapper">
        {/* Top Bar */}
        <div className="py-2" style={{ backgroundColor: "#FCDBC9" }}>
          <div className="container-fluid">
            <div className="row align-items-center">
              {/* Logo */}
              <div className="col-lg-2 col-md-3 col-6 text-center text-md-start">
                <ImageWithBasePath
                  src="assets/img/iBizAccounts.png"
                  alt="logo"
                  className="img-fluid"
                  style={{ maxHeight: "60px" }}
                />
              </div>

              {/* Login Form */}
              <div className="col-lg-6 col-md-9 col-12 ms-auto">
                <form
                  className="d-flex flex-column flex-sm-row gap-2 align-items-center"
                  onSubmit={handleSubmit}
                >
                  <div className="flex-grow-1">
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Username"
                        value={Username}
                        onChange={(e) => setUserName(e.target.value)}
                      />
                      <span className="input-group-text">
                        <i className="fa fa-user" />
                      </span>
                    </div>
                  </div>

                  <div className="flex-grow-1">
                    <div className="input-group">
                      <input
                        type={isPasswordVisible ? "text" : "password"}
                        className="form-control"
                        placeholder="Enter Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                      />
                      <button
                        type="button"
                        className="input-group-text bg-white border"
                        onClick={togglePasswordVisibility}
                        style={{ cursor: "pointer" }}
                      >
                        <i
                          className={`ti ${
                            isPasswordVisible
                              ? "fa-solid fa-eye"
                              : "fa-solid fa-eye-slash"
                          }`}
                        />
                      </button>
                    </div>
                  </div>

                  <div>
                    <button
                      type="submit"
                      className="btn btn-primary px-4"
                      disabled={loading}
                    >
                      {loading ? (
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                        />
                      ) : (
                        "Sign In"
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        {/* Main Showcase */}
        <div className="account-content py-3">
          <Spin spinning={dataloading} size="large" tip="Loading...">
            <div className="container-fluid">
              <div className="row g-4">
                {/* Content Section */}
                <div className="col-lg-6 d-flex flex-column">
                  <div className="flex-grow-1">
                    <div className="mb-2">
                      <h1 className="  mb-2 " style={{ color: "#f59e42" }}>
                        {title?.title || "Welcome to IBIZ"}
                      </h1>
                      <h4 className="">{title?.subtitle}</h4>
                    </div>

                    <div className="solutions-swiper-container mb-4">
                      <Swiper
                        effect={"coverflow"}
                        grabCursor={true}
                        centeredSlides={true}
                        loop={true}
                        slidesPerView={"auto"}
                        autoplay={{
                          delay: 4000,
                          disableOnInteraction: false,
                        }}
                        coverflowEffect={{
                          rotate: 0,
                          stretch: 0,
                          depth: 120,
                          modifier: 2,
                          scale: 0.85,
                          slideShadows: false,
                        }}
                        pagination={{ clickable: true }}
                        modules={[EffectCoverflow, Pagination, Autoplay]}
                        className="solutions-swiper"
                      >
                        {featureCards.map((card, index) => (
                          <SwiperSlide key={index}>
                            <a
                              href={card.link}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-decoration-none"
                            >
                              <div className="solution-card">
                                <img
                                  src={card.image}
                                  alt={card.alt}
                                  className="solution-image"
                                />
                              </div>
                            </a>
                          </SwiperSlide>
                        ))}
                      </Swiper>
                    </div>

                    <div className="row g-3">
                      {featureCards.slice(0, 2).map((card, index) => (
                        <div
                          key={index}
                          className="col-lg-6 col-md-6 col-sm-12"
                        >
                          <a
                            href={card.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-decoration-none"
                          >
                            <div
                              className="card border-0 shadow-sm rounded-4 overflow-hidden w-100"
                              style={{
                                // width: "320px",
                                height: "180px",
                              }}
                            >
                              <div className="d-flex h-100">
                                <img
                                  src={card.image}
                                  alt={card.alt}
                                  className="w-100 h-100"
                                  style={{ objectFit: "fill" }}
                                />
                              </div>
                            </div>
                          </a>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* <div>
                   
                    {svgicons.length > 0 && (
                      <div className="mt-2">
                        <div className="row g-3 text-center text-md-start">
                          {svgicons.map((item, idx) => (
                            <div key={idx} className="col-6 col-md-3 col-lg-3">
                              <div className="d-flex align-items-center justify-content-center gap-2 bg-white rounded-4 shadow-sm py-3 px-3">
                                <i
                                  className={`${item.svg} fs-4 text-primary`}
                                />
                                <span className="fw-medium text-dark small">
                                  {item.name}
                                </span>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div> */}
                </div>
                {/* Carousel Section */}
                <div className="col-lg-6">
                  <div
                    className="position-relative rounded-4 overflow-hidden"
                    style={{
                      minHeight: "520px",
                      background: "linear-gradient(120deg, #0b1f45, #2567d8)",
                    }}
                  >
                    {featureCarouselSlides.map((image, index) => (
                      <div
                        key={index}
                        className={`position-absolute w-100 h-100 transition-opacity ${
                          index === activeSlide ? "opacity-100" : "opacity-0"
                        }`}
                        style={{ transition: "opacity 0.6s ease" }}
                      >
                        <img
                          src={image.image}
                          alt={image.title}
                          className="w-100 h-100 object-fit-fill"
                        />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </Spin>
        </div>

        {/* Footer */}
        <footer
          className=" text-white py-5"
          style={{ backgroundColor: "#DC410D" }}
        >
          <div className="container-fluid px-4 px-lg-5">
            <div className="row g-5">
              {/* Brand Column */}
              <div className="col-lg-5">
                <div className="d-flex flex-column h-100">
                  <img
                    src={footerLogo1}
                    alt="footer logo"
                    className="img-fluid mb-4"
                    style={{ maxWidth: "260px" }}
                  />

                  <div className="d-flex gap-3 mb-4">
                    <a
                      href="https://www.instagram.com/pereco_india/?igsh=MXFrNXRieHozMHVicA%3D%3D#"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-outline-light rounded-circle d-flex align-items-center justify-content-center"
                      style={{ width: "44px", height: "44px" }}
                    >
                      <i className="fa-brands fa-instagram" />
                    </a>
                    <a
                      href="https://www.facebook.com/Perecoindia/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-outline-light rounded-circle d-flex align-items-center justify-content-center"
                      style={{ width: "44px", height: "44px" }}
                    >
                      <i className="fa-brands fa-facebook" />
                    </a>
                    <a
                      href="https://x.com/PerecoIndia"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-outline-light rounded-circle d-flex align-items-center justify-content-center"
                      style={{ width: "44px", height: "44px" }}
                    >
                      <i className="fa-brands fa-x-twitter" />
                    </a>
                    <a
                      href="https://www.linkedin.com/company/perennial-code/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-outline-light rounded-circle d-flex align-items-center justify-content-center"
                      style={{ width: "44px", height: "44px" }}
                    >
                      <i className="fa-brands fa-linkedin" />
                    </a>
                    <a
                      href="https://www.youtube.com/@perecoindia"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-outline-light rounded-circle d-flex align-items-center justify-content-center"
                      style={{ width: "44px", height: "44px" }}
                    >
                      <i className="fa-brands fa-youtube" />
                    </a>
                  </div>

                  <a
                    href="https://www.google.com/maps/dir//opp.+ASK+Educational+Society,+Vittal+Nagar,+Adikmet,+Hyderabad,+Telangana+500044/@17.4059614,78.4262689,12z/data=!4m8!4m7!1m0!1m5!1m1!1s0x3bcb99a6320e26bb:0x199d77b1f4faac56!2m2!1d78.5086707!2d17.4059783?entry=ttu"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white text-decoration-none d-flex gap-3 align-items-start"
                  >
                    <i className="fa-solid fa-location-dot mt-1 fs-5" />
                    <div>
                      Vidya Nagar Street Number 7,
                      <br />
                      Hyderabad, Telangana, 500044
                    </div>
                  </a>
                </div>
              </div>

              {/* Contact & Links */}
              <div className="col-lg-7">
                <div className="row g-5">
                  {/* Contact */}
                  <div className="col-md-6">
                    <h5 className="fw-bold mb-4 text-white">Contact</h5>
                    <div className="d-flex gap-3 mb-3">
                      <i className="fa-solid fa-phone mt-1" />
                      <span>+91 8297230010</span>
                    </div>
                    <div className="d-flex gap-3">
                      <i className="fa-solid fa-envelope mt-1" />
                      <div>
                        <div>sales@perennialcode.in</div>
                        <div>support@perennialcode.in</div>
                        <div>info@perennialcode.in</div>
                      </div>
                    </div>
                  </div>

                  {/* Quick Links */}
                  <div className="col-md-6">
                    <h5 className="fw-bold mb-4 text-white">Quick Links</h5>
                    <ul className="list-unstyled">
                      <li className="mb-2">
                        <a
                          href="https://www.perennialcode.in"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-white text-decoration-none"
                        >
                          Home
                        </a>
                      </li>
                      <li className="mb-2">
                        <a
                          href="https://www.perennialcode.in/aboutus"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-white text-decoration-none"
                        >
                          About Us
                        </a>
                      </li>
                      <li className="mb-2">
                        <a
                          href="https://www.perennialcode.in/solutions"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-white text-decoration-none"
                        >
                          Solutions
                        </a>
                      </li>
                      <li className="mb-2">
                        <a
                          href="https://www.perennialcode.in/contactus"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-white text-decoration-none"
                        >
                          Contact Us
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <hr className="my-2 border-secondary" />

            <div className="text-center text-white-50 small">
              &copy; 2026 Perennial Code. All Rights Reserved.
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default Signin;
